<template>
  <div>
    <div class="modal" :class="{'is-active':showIntroModal}" ref="introModal">
      <div class="modal-background" @click.prevent="showIntroModal=false"></div>
      <div class="modal-content box">
        <div class="columns is-centered">
          <div class="column cambridge-pic">
            <img :src="SplashPics[0]" class="image" />
          </div>
        </div>
        <div class="has-text-centered welcome-text section">
          <p
            class="is-size-3"
          >Welcome, {{user.first_name}}, to the Cambridge Certificate in Teaching and Learning</p>
        </div>
        <button class="button" @click.prevent="completeIntro">Start your journey</button>
        <div class="columns is-centered">
          <div class="column gen-logo">
            <img :src="SplashPics[1]" class="image" />
          </div>
        </div>
      </div>
      <button class="modal-close is-large" @click.prevent="showIntroModal=false" aria-label="close"></button>
    </div>

    <section class="section">
      <div class="container columns is-centered is-fluid is-multiline">
        <!-- <div class="column">
          <img :src="welcomeGraphic" class="welcomeGraphic" alt />
        </div>-->

        <div class="column is-half">
          <div class>
            <div class="columns">
              <div class="column">
                <filebrowser :boxOff="true" :header="'Journal entry'" :files="journals" />
              </div>
            </div>
          </div>
        </div>
        <div class="column is-half">
          <div class>
            <div class="columns">
              <div class="column">
                <taskbrowser :boxOff="true" :header="'Tasks'" :files="documents" />
              </div>
            </div>
          </div>
        </div>

        <!-- To do list widget -->
        <div class="column is-half">
          <div>
            <div class="columns is-vcentered">
              <div class="column has-text-left">
                <h2 class="widget-title">Upcoming Events</h2>
              </div>
            </div>
            <div v-for="(event, i) in withinAWeek(eventsList)" :key="i">
              <listItem @todoBriefClicked="onTodoBriefClick" :hasBriefs="false" :event="event"></listItem>
            </div>
          </div>
        </div>
        <div class="column is-half">
          <div class="box" style="display: none">
            <div class="columns is-vcentered">
              <div class="column has-text-left">
                <h2 class="widget-title">Progress</h2>
              </div>
            </div>
            <div class="columns is-multiline is-centered">
              <div class="column is-narrow">
                <h3>Projects</h3>
                <ringprogress :progress="projectCompletion" />
                <p>{{completedProjects.length}} / {{projects.length}} projects complete</p>
              </div>
              <div class="column is-narrow">
                <h3>Lessons</h3>
                <ringprogress :progress="lessonProgress" />
                <p>{{user.completedLessons.length}} / {{numberOfLessons}} lessons complete</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import FileBrowser from "@/components/files/MiniBrowser";
import TaskBrowser from "@/components/dashboard/TaskBrowser";
import { ChatClient } from "../clients/ChatClient";
import { UserClient } from "../clients/UserClient";
import { CalendarClient } from "../clients/CalendarClient";

import { mapState } from "vuex";
import ListItem from "@/components/calendar/ListItem";
import RingProgress from "@/components/dashboard/RingProgress";

export default {
  name: "Dashboard",
  components: {
    ListItem,
    filebrowser: FileBrowser,
    taskbrowser: TaskBrowser,
    ringprogress: RingProgress
  },
  data: function() {
    return {
      // leftCircle: { transform: "rotate(" + 180 + "deg)" },
      IconLink: [
        require("@/assets/img/icons/e-portfolio-icon.svg"),
        require("@/assets/img/icons/my-mentor-icon.svg"),
        require("@/assets/img/icons/forum-icon.svg"),
        require("@/assets/img/icons/my-account-icon.svg")
      ],
      SplashPics: [
        require("@/assets/img/cambridge-logo-lms.png"),
        require("@/assets/img/genex-logo.svg")
      ],
      user: this.$store.state.auth.user,
      mentor: Object,
      welcomeGraphic: require("@/assets/img/welcome-graphic.png"),
      events: [],
      rawEvents: [],
      selectedEvent: {},
      showEventBox: false,
      bookings: [],
      projects: [],
      todos: [],
      showIntroModal: !this.$store.state.auth.user.has_seen_splash
    };
  },
  computed: {
    ...mapState({
      calendar(state) {
        return state.calendar;
      },
      journals(state) {
        let sortingList = state.documentStore.documents.filter(
          document => document.is_in_journal && !document.project
        );
        sortingList = sortingList.sort(function(a, b) {
          return new Date(b.updated_at.date) - new Date(a.updated_at.date);
        });
        return sortingList.slice(0, 5);
      },
      documents(state) {
        let sortingList = state.documentStore.documents.filter(
          document =>
            !document.is_in_journal &&
            Number.isInteger(document.project_id) &&
            document.project
        );
        sortingList = sortingList.sort(function(a, b) {
          return new Date(b.updated_at.date) - new Date(a.updated_at.date);
        });
        return sortingList.slice(0, 5);
      }
    }),
    completedProjects() {
      return this.user.user_project_documents.filter(
        document => document.mentor_id != null
      );
    },
    projectCompletion() {
      let sum = Math.round(
        (this.completedProjects.length / this.projects.length) * 100
      );
      if (sum > 100) {
        sum = 100;
      }

      if (Number.isNaN(sum)) {
        sum = 0;
      }
      return sum;
    },
    eventsList() {
      let sortingList = this.events;
      return sortingList.sort(function(a, b) {
        return new Date(a.end) - new Date(b.end);
      });
    },
    numberOfLessons() {
      let total = 0;
      this.user.courses.forEach(course => {
        course.modules.forEach(module => {
          total += module.lessons.length;
        });
      });
      return total;
    },
    lessonProgress() {
      return Math.round(
        (this.user.completedLessons.length / this.numberOfLessons) * 100
      );
    }
  },

  methods: {
    onTodoBriefClick() {},
    onlyFuture(events) {
      let sortingList = events;
      let tempList = [];
      sortingList.forEach(element => {
        if (this.pastOrFuture(element.start) == "upcoming") {
          tempList.push(element);
        }
      });
      return tempList.sort(function(a, b) {
        return new Date(a.end) - new Date(b.end);
      });
    },
    withinAWeek(events) {
      let sortingList = events;
      let tempList = [];
      sortingList.forEach(element => {
        if (this.withinOneWeekPastAndFuture(element.start) == true) {
          tempList.push(element);
        }
      });
      return tempList.sort(function(a, b) {
        return new Date(a.end) - new Date(b.end);
      });
    },

    truncate(text) {
      if (text.length < 30) {
        return text;
      } else {
        return text.substring(0, 27) + "...";
      }
    },

    processDate(date) {
      return this.$moment(date).format("YYYY-MM-DD HH:mm");
    },
    processTodoDate(date) {
      return this.$moment(date)
        .add(30, "minutes")
        .format("YYYY-MM-DD HH:mm");
    },
    withinOneWeekPastAndFuture(date) {
      let now = this.$moment();
      let subject = this.$moment(new Date(date));

      let diffInDays = subject.diff(now, "days");

      if (diffInDays > 7 || diffInDays < -7) {
        return false;
      } else {
        return true;
      }
    },
    pastOrFuture(date) {
      let now = new Date();
      let subject = new Date(date);

      if (subject >= now) {
        return "upcoming";
      } else {
        return "passed";
      }
    },

    processEvents(raw) {
      raw.todos.forEach(element => {
        this.todos.push({
          class: this.pastOrFuture(element.due_date),
          end: this.processDate(element.due_date),
          start: this.processDate(element.due_date),
          type: "todo",
          title: this.truncate(element.todo),
          brief: element.todo
        });
      });

      raw.bookings.forEach(element => {
        this.bookings.push({
          class: this.pastOrFuture(element.start_date),
          start: this.processDate(element.start_date),
          end: this.processDate(element.start_date),
          name: element.name,
          title: "Mentor Chat",
          type: "booking"
        });
      });
      raw.projects.forEach(element => {
        this.projects.push({
          class: element.status,
          start: this.processDate(element.project.pivot.due_date),
          end: this.processDate(element.project.pivot.due_date),
          title: element.project.name,
          id: element.project.id,
          brief: element.project.content,
          allDay: true,
          type: "project",
          project: element.project.id,
          status: element.status
        });
      });
      this.todos.forEach(element => {
        this.events.push(element);
      });
      this.bookings.forEach(element => {
        this.events.push(element);
      });
      this.projects.forEach(element => {
        this.events.push(element);
      });
    },

    completeIntro() {
      UserClient.updateSplashMeta().then(() => {
        this.showIntroModal = false;
      });
    },
    getCalendar() {
      CalendarClient.getCalendar(this.$store.state.auth.user.groups[0].id)
        .then(response => {
          this.rawEvents = response.data.events;
          this.processEvents(this.rawEvents);
        })
        .catch(err => {
          console.log(err);
        });
    },

    getMentor(callback) {
      ChatClient.getMentor()
        .then(response => {
          this.mentor = response.data.data.mentor;
        })
        .catch(error => {
          console.log(error.response);
        });
    }
  },
  mounted() {
    this.$store.dispatch("GET_USER_DOCUMENTS");
    this.$store.dispatch("lastLesson/getLastLesson");
    this.getCalendar();
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/variables";

.widget-icon-container {
  height: auto;
  width: 100%;
}
.widget-icon {
  height: auto;
  width: 100%;
}
.welcomeGraphic {
  width: 60%;
}

.gen-logo {
  max-width: 15rem;
  padding-top: 8rem;
}
.cambridge-pic {
  max-width: 30rem;
}
.welcome-text {
  color: $pantoneBlue;
  padding-bottom: 0.5rem !important;
}

.widget-title {
  color: $orange;
  font-weight: bold !important;
}
</style>

